export default "__VITE_ASSET__56114767__"